import * as CryptoJS from 'crypto-js';

/**
 * Контрольная сумма (MD5) полезной нагрузки документа. Используется как признак «данные не изменились
 * с момента выгрузки»: если сохранённая {@code uploadedChecksum} равна контрольной сумме текущих
 * данных — документ выгружен в актуальной версии; иначе он изменён и подлежит повторной отправке.
 *
 * <p>Единый источник вычисления для отправки (сравнение перед выгрузкой) и хранения (сброс отметки об
 * отправке при изменении данных) — иначе критерий «отправлено» расходился бы между модулями.
 */
export function calculateDocumentChecksum(data: object): string {
  const jsonString = JSON.stringify(data);
  const { buffer } = new TextEncoder().encode(jsonString);
  const wordArray = CryptoJS.lib.WordArray.create(buffer);
  return CryptoJS.MD5(wordArray).toString();
}
